export default {
  satuanKerja: (state, getters) => {
    return state.satuanKerja;
  },
  total: (state, getters) => {
    return state.total;
  },
};
